/**
* @File * @Author huyuying
* @Author huyuying liubin
* @FilePath src/main/router/modules/lx.js
*/
export default {
	// 404页面
	//notFound:() => import( /* webpackChunkName: "NotFound" */ '../../views/ymt/notFound.vue'),
	// 工作台
	index:() => import( /* webpackChunkName: "index" */ '../../views/ymt/index.vue'),
	// 登录页
	login:() => import( /* webpackChunkName: "workbench" */ '../../views/ymt/login.vue'),
	// 各机构报价详情
	quoteDetail:() => import( /* webpackChunkName: "workbench" */ '../../views/ymt/quoteDetail.vue'),
	// 询价详情
	xjDetail:() => import( /* webpackChunkName: "workbench" */ '../../views/ymt/xjDetail.vue'),
	// 个人中心
	personalCenter:() => import( /* webpackChunkName: "workbench" */ '../../views/ymt/personalCenter.vue'),
	// 富民下载
    downLoad:() => import( /* webpackChunkName: "workbench" */ '../../views/ymt/downLoad.vue'),
    //机构推荐人介绍
	referrerInfo:() => import( /* webpackChunkName: "workbench" */ '../../views/ymt/referrerInfo.vue'),

    // ---链信----
    repayment:() => import( /* webpackChunkName: "workbench" */ '../../views/Lx/H5/repayment.vue'),//还款提醒
    financing:() => import( /* webpackChunkName: "workbench" */ '../../views/Lx/H5/financing.vue'),//融资详情
    examine:() => import( /* webpackChunkName: "workbench" */ '../../views/Lx/H5/examine.vue'),//审批结果
    corporateFriends:() => import( /* webpackChunkName: "workbench" */ '../../views/Lx/H5/corporateFriends.vue'),//企业好友(好友邀请)
    imprintDocument:() => import( /* webpackChunkName: "workbench" */ '../../views/Lx/H5/imprintDocument.vue'),//印迹文档
    introduceLx:() => import( /* webpackChunkName: "workbench" */ '../../views/Lx/H5/introduceLx.vue'),//链信介绍
    introduceYx:() => import( /* webpackChunkName: "workbench" */ '../../views/Lx/H5/introduceYx.vue'),//链信云心融资介绍
    appIntroduce:() => import( /* webpackChunkName: "workbench" */ '../../views/Lx/H5/appIntroduce.vue'),//应用介绍
    invalid:() => import( /* webpackChunkName: "workbench" */ '../../views/Lx/H5/invalid.vue'),//失效
    lxDown:() => import( /* webpackChunkName: "workbench" */ '../../views/Lx/H5/lxDown.vue'),//链信下载
	imageShow:() => import( /* webpackChunkName: "workbench" */ '../../views/Lx/H5/imageShow.vue'),//分享图片
	taskDetail:() => import( /* webpackChunkName: "workbench" */ '../../views/Lx/H5/taskDetail.vue'),//分享图片
	pdfView:() => import( /* webpackChunkName: "workbench" */ '../../views/Lx/H5/pdfView.vue'),//分享图片

	jumpLxApp:() => import( /* webpackChunkName: "workbench" */ '../../views/Lx/blindBox/jumpLxApp.vue'),//在链信中打开此页面
	index:() => import( /* webpackChunkName: "workbench" */ '../../views/Lx/blindBox/index.vue'),//盲盒首页
	blindBoxDetails:() => import( /* webpackChunkName: "workbench" */ '../../views/Lx/blindBox/blindBoxDetails.vue'),//盲盒详情
	myBlindBox:() => import( /* webpackChunkName: "workbench" */ '../../views/Lx/blindBox/myBlindBox.vue'),//我的盲盒
	emptyBox:() => import( /* webpackChunkName: "workbench" */ '../../views/Lx/blindBox/emptyBox.vue'),//没抽中盲盒

	FactoringShare:() => import( /* webpackChunkName: "FactoringShare" */ '../../views/Lx/H5/FactoringShare.vue'),//跨行再保理分享

	shareDetail:() => import( /* webpackChunkName: "workbench" */ '../../views/Lx/companyCircle/shareDetail.vue'),//企业圈-详情分享页面
	articleDetail:() => import( /* webpackChunkName: "workbench" */ '../../views/Lx/companyCircle/articleDetail.vue'),//企业圈-详情

    createPlan:() => import( /* webpackChunkName: "createPlan" */ '../../views/Lx/H5/createPlan.vue'),//共创计划H5页面


    sign:() => import( /* webpackChunkName: "sign" */ '../../views/Lx/sign.vue'),//协议签署
	filingSign:() => import( /* webpackChunkName: "sign" */ '../../views/Lx/filingSign.vue'),//协议签署

	yxUsageGuide:() => import( /* webpackChunkName: "yxUsageGuide" */ '../../views/Lx/H5/yxUsageGuide.vue'),//云信使用指南

	/* LXN-929 */
	editorPreview:() => import( /* webpackChunkName: "editorPreview" */ '../../views/Lx/editorPreview/index.vue'),//链信图文预览
	/* end */
}